<template>
  <!-- for new record set :create-mode="true" -->
  <complex-activity
      :save-enabled="true"
      :create-mode="false"

      :fluid-bottom-line="false"
      @saveAll="saveAll"
  >

    <!-- Tab 1 with simple data -->
    <activity-tab title = "Simple" icon = "user"
      :edited = 'true' :error = 'true'
      @activate="simpleActivated"
    >
      <simple-activity>
        <!-- HEADER -->
        <!-- Left side button - primary actions -->
        <template v-slot:primaryButton>
          <footer-button type="NewOnTab1" @new="newClickOnTab1"></footer-button>
        </template>
        <!-- ... -->
        <!-- HEADER END -->

        <!-- CONTENT -->
        <b-container class="pt-1 px-2" fluid="true">
          <b-row no-gutters>
            <b-col>
              TEXT on tab1
            </b-col>
          </b-row>
        </b-container>
      </simple-activity>
    </activity-tab>


    <!-- Tab 2 with record edit -->
    <activity-tab title = "Simple" icon = "user"
                  :edited = 'true' :error = 'true'
                  @activate="simpleActivated"
    >
      <record-edit-activity
          :save-enabled="true"
          :edit-enabled="true"
          :read-only-mode="tab2ReadOnlyMode"
          :create-mode="false"
          :errorMessage="tab2ErrorMessage"
          :fluid-bottom-line="false"
          :show-delete="false"

          @edit="tab2edit"
          @save="tab2save"
      >

  
        <!-- HEADER - the same as in record-edit-activity -->
        <!-- -->

        <b-container class="pt-1 px-2" >
          <b-row no-gutters>
            <b-col>
              XXX
  <!--            <span v-if="tab2ReadOnlyMode" v-text="formValue"></span>-->
  <!--            <b-input v-else v-model="formValue" ref="firstInput"></b-input>-->
            </b-col>
          </b-row>
        </b-container>
        <!-- CONTENT END-->

        <template v-slot:bottomLine>
          Some stuff on the bottom - on tab2
        </template>

      </record-edit-activity>
    </activity-tab>

    <template v-slot:bottomLine>
        Some common stuff on the bottom
    </template>

    <template v-slot:footer>

    </template>
  </complex-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import Perms from "@/server/Perms";
import PermissionsSet from "@/server/PermissionsSet";
import FooterButton from "@/components/navbar/FooterButton";
import Log from "@/utils/Log";
import DialogManager from "@/utils/DialogManager";
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity";
import RecordEditActivity from "@/activity/templates/layouts/RecordEditActivity";
import ReachInput from "@/components/inputs/ReachInput";
import ComplexActivity from "@/activity/templates/layouts/ComplexActivity";
import ActivityTab from "@/activity/templates/layouts/tabs/ActivityTab";


export default {
  name: "ComplexActivityTemplate",
  components: {ActivityTab, ComplexActivity, ReachInput, RecordEditActivity, SimpleActivity, FooterButton },
  permission: Perms.SUPERUSER,

  created() {
  },

  methods: {
    ...Activity.methods,

    // --------------------------------------
    //   Shared methods
    // --------------------------------------

    getTitle() {
      return "Complex Activity";
    },
    async canClose(){
      // return await DialogManager.canClose(this.unsavedChanges || !this.readOnlyMode);
    },

    async saveAll(autoClose){
      // tab1 save

      await DialogManager.info($tr("saveClicked","Save clicked"),$tr("recordSaved","Record saved"));
      let result = "Lol such result";
      this.setResult(result);
      this.$emit("saved", result);

      this.readOnlyMode = true;
      if(autoClose){
        this.close();
      }
    },

    // --------------------------------------
    //   TAB methods
    // --------------------------------------
    simpleActivated(){
        // tab activated
    },

    newClickOnTab1(){

    },

    tab2save(){

    },

    tab2edit(){

    }

  },
  props:{

  },
  data:function(){return {
    tab2ReadOnlyMode: false,
    tab2ErrorMessage: '',

    permissions: new PermissionsSet(),
  }}
}
</script>
